<template>
  <v-container text-xs-center>
    <div id="app">
      <v-app id="inspire">
        <v-card>
          <v-card-title>
            Drill Lib Statistics
          </v-card-title>
          <v-container grid-list-md>
            <v-layout row wrap>
              <v-flex xs6 lg6>
                <v-spacer></v-spacer>
                <bar-chart
                  :chart-data="this.favoriteDrillStats"
                  :options="options"
                  title="Top Users Statistics"
                ></bar-chart>
              </v-flex>
              <v-flex xs6 lg6>
                <v-spacer></v-spacer>
                <bar-chart
                  :chart-data="this.drillStats"
                  :options="options"
                  title="Drill Statistics"
                ></bar-chart>
              </v-flex>
            </v-layout>
          </v-container>
          <!--v-layout v-resize="onResize" column style="padding-top:56px">
            <v-data-table
              :headers="headers"
              :items="favoriteDrillLib.edges"
              :search="search"
              :footer-props="rowsPerPageItems"
              group-key="node.userId"
            >
              <v-alert
                slot="no-results"
                :value="true"
                color="error"
                icon="warning"
              >
                Your search for "{{ search }}" found no results.
              </v-alert>
            </v-data-table>
          </v-layout-->
        </v-card>
      </v-app>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import BarChart from "../constants/BarChart.js";

export default {
  components: {
    BarChart
  },
  data() {
    return {
      search: "",
      options: null,
      onResize: null,
      rowsPerPageItems: {
        "items-per-page-options": [50, 100, 150, -1]
      },
      isMobile: false,
      pagination: {
        rowsPerPage: 15
      },
      headers: [
        {
          text: "FavDrillId",
          align: "left",
          sortable: true,
          value: "node.favdrillId"
        },
        { text: "User", value: "node.userId" },
        { text: "Drill", value: "node.drillId" }
      ],
      favoriteDrillStats: null
    };
  },
  computed: {
    ...mapGetters(["loading", "error", "user", "favoriteDrillLib", "drillLib"])
  },
  created() {
    this.handleGetDrillList();
    this.handleGetFavoriteDrill();
    this.fillData();
  },
  watch: {
    //  user(value){
    //
    //  //
    //    // if user value changes б redirect to home page
    //    if(value){
    //      this.$router.push("/landing");
    //    }
    //  }
    //
  },
  methods: {
    rgba(r, g, b, a) {
      return ["rgba(", r, ",", g, ",", b, ",", a, ")"].join("");
    },
    getFavoriteDrillStats() {
      if (this.favoriteDrillLib.edges) {
        var dataset = Array.from(
          new Set(this.favoriteDrillLib.edges.map(item => item.node.userId))
        ).map(userId => {
          return {
            userId: this.favoriteDrillLib.edges.filter(
              item => item.node.userId == userId
            )[0].node.user.userName,
            likesN: this.favoriteDrillLib.edges.filter(
              item => item.node.userId == userId
            ).length,
            drillsN: this.drillLib.edges.filter(
              item => item.node.user.userId == userId
            ).length,
            backgroundColorDrill: "rgba(153, 202, 255, 0.5)", // this.rgba(userId,userId,userId,0.2),
            borderColor: this.rgba(userId, userId, userId, 1),
            backgroundColorLikes: "rgba(255, 99, 132, 0.5)" // this.rgba(userId,userId,userId,0.2),
            //  	  workoutsN: null
            //        lastName: this.athleteOfficialResults.find(
            //         item => item.node.athleteId === athleteId
            //        ).node.athlete.lastName
          };
        });
      }
      return dataset;
    },
    getDrillStats() {
      if (this.drillLib.edges) {
        var dataset = Array.from(
          new Set(this.drillLib.edges.map(item => item.node.sportType))
        ).map(sportType => {
          return {
            sportType: sportType,
            drillsN: this.drillLib.edges.filter(
              item => item.node.sportType == sportType
            ).length,
            drillsPublic: this.drillLib.edges.filter(
              item =>
                item.node.sportType == sportType && item.node.status == "Public"
            ).length,
            drillsWithVideo: this.drillLib.edges.filter(
              item => item.node.sportType == sportType && item.node.videoUrl
            ).length,
            backgroundColorDrill: "rgba(153, 202, 255, 0.3)", // this.rgba(userId,userId,userId,0.2),
            borderColor: "rgba(128,128,128,0.5)",
            backgroundColorLikes: "rgba(255, 99, 132, 0.3)", // this.rgba(userId,userId,userId,0.2),
            backgroundColorPublic: "rgba(0,188,212, 0.3)", // this.rgba(userId,userId,userId,0.2),
            backgroundColorDrillWithVideo: "rgba(107,194,130, 0.3)"
          };
        });
      }
      return dataset;
    },
    fillData() {
      this.favoriteDrillStats = {
        labels: this.getFavoriteDrillStats().map(item => item.userId),
        datasets: [
          {
            label: "Likes #",
            data: this.getFavoriteDrillStats().map(item => item.likesN),
            backgroundColor: this.getFavoriteDrillStats().map(
              item => item.backgroundColorLikes
            ),
            borderColor: this.getFavoriteDrillStats().map(
              item => item.borderColor
            ),
            borderWidth: 1,
            link: "/lib/drill_lib"
          },
          {
            label: "Drills #",
            data: this.getFavoriteDrillStats().map(item => item.drillsN),
            backgroundColor: this.getFavoriteDrillStats().map(
              item => item.backgroundColorDrill
            ),
            borderColor: this.getFavoriteDrillStats().map(
              item => item.borderColor
            ),
            borderWidth: 1,
            link: "/lib/drill_lib"
          }
        ]
      };
      this.drillStats = {
        labels: this.getDrillStats().map(item => item.sportType),
        datasets: [
          {
            label: "Drills #",
            data: this.getDrillStats().map(item => item.drillsN),
            backgroundColor: this.getDrillStats().map(
              item => item.backgroundColorLikes
            ),
            borderColor: this.getDrillStats().map(item => item.borderColor),
            borderWidth: 1,
            link: "/lib/drill_lib"
          },
          {
            label: "DrillsPublic #",
            data: this.getDrillStats().map(item => item.drillsPublic),
            backgroundColor: this.getDrillStats().map(
              item => item.backgroundColorDrill
            ),
            borderColor: this.getDrillStats().map(item => item.borderColor),
            borderWidth: 1,
            link: "/lib/drill_lib"
          },
          {
            label: "DrillsWith Video #",
            data: this.getDrillStats().map(item => item.drillsWithVideo),
            backgroundColor: this.getDrillStats().map(
              item => item.backgroundColorDrillWithVideo
            ),
            borderColor: this.getDrillStats().map(item => item.borderColor),
            borderWidth: 1,
            link: "/lib/drill_lib"
          }
        ]
      };
    },
    handleGetDrillList() {
      //reach out of Vuex store, fire action that gets Drill
      if (!this.drillLib.edges) {
        this.$store.dispatch("allDrillLib", {
          //   clubId: this.$route.params.club
        });
      }
    },
    handleGetFavoriteDrill() {
      //reach out of Vuex store, fire action that gets Drill
      if (!this.favoriteDrillLib.edges) {
        this.$store.dispatch("allFavoriteDrillLib", {
          //userId: this.user.userId
        });
      }
    }
  },

  mounted() {
    if (!this.favoriteDrillStats) {
      setInterval(this.fillData, 2000);
    }
  }
};
</script>

<style>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
